import React from 'react';
import { useSearchParams } from 'react-router-dom';
import EngagementMeetings from '../../../ConnectMarketplaceDashboard/EngagementMeetings/EngagementMeetings';

export const SupportMeetings = () => {
    const [searchParams] = useSearchParams();
    const highlightMeetingId = searchParams.get('selectedMeeting') ? Number(searchParams.get('selectedMeeting')) : undefined;

    return (
        <EngagementMeetings
            engagementId={0}
            isBrokerExist={false}
            isSupportMode={true}
            hideMeetingButtons={true}
            customApiEndpoint="/api/Marketplace/MarketplaceMeetings"
            selectedMeetingId={highlightMeetingId}
        />
    );
};

export default SupportMeetings;